"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variantClass = exports.generateRow = exports.generateHeadCells = exports.generateBody = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const generateHeadCells = data => {
  if (data.head && data.head.length) {
    return data.head.map((cell, index) => {
      return /*#__PURE__*/_react.default.createElement("th", {
        key: `t-head-cell-${index}`,
        id: `t-head-cell-${index}`
      }, cell);
    });
  } else return [];
};
exports.generateHeadCells = generateHeadCells;
const generateRow = (row, rowNum) => {
  return row.map((cell, index) => {
    if (cell && cell[0]) {
      const plainText = typeof cell[0] === "string";
      if (plainText) {
        return /*#__PURE__*/_react.default.createElement("td", {
          className: index === 0 ? `ter-table__first-row ter_table_row` : `ter-table__reg-row ter_table_row`,
          key: `cell-${rowNum}-${index}`
        }, cell);
      } else if (Object.keys(cell[0])[0] === "icon") {
        return /*#__PURE__*/_react.default.createElement("td", {
          className: index === 0 ? `ter-table__first-row ter_table_row` : `ter-table__reg-row ter_table_row`,
          key: `cell-${rowNum}-${index}`
        }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          type: cell[0].icon,
          size: cell[0].size ? cell[0].size : "16px"
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement("td", {
          className: index === 0 ? `ter-table__first-row ter_table_row` : `ter-table__reg-row ter_table_row`,
          key: `cell-${rowNum}-${index}`
        }, cell);
      }
    }
  });
};
exports.generateRow = generateRow;
const generateBody = data => {
  if (data.body && data.body.length) {
    return data.body.map((row, index) => {
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: `row-${index}`
      }, generateRow(row, index));
    });
  } else return [];
};
exports.generateBody = generateBody;
const variantClass = className => {
  if (className === true) {
    return "ter-table ter-table--loose";
  } else if (typeof className === "string") {
    return `ter-table ${className}`;
  } else return "ter-table";
};
exports.variantClass = variantClass;